/**
 * Add spaces between uppercase words in camel case or pascal case strings. https://stackoverflow.com/a/4149671.
 * @example BrandFolder => Brand Folder
 * @param {string} camelCaseOrPascalCase string
 * @returns string
 */
export const formatCamelOrPascalCaseToSpaces = (camelCaseOrPascalCase: string): string => camelCaseOrPascalCase.split(/(?=[A-Z])/).join(' ');
